var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},_vm._l(([1, 2, 3, 4, 5]),function(item,index){return _c('skeleton-loader',{key:index,staticClass:"loading-card",attrs:{"type":"article, actions"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }